import { render, staticRenderFns } from "./ArchiveOverview.vue?vue&type=template&id=be4d6710&scoped=true"
import script from "./ArchiveOverview.vue?vue&type=script&lang=js"
export * from "./ArchiveOverview.vue?vue&type=script&lang=js"
import style0 from "./ArchiveOverview.vue?vue&type=style&index=0&id=be4d6710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4d6710",
  null
  
)

export default component.exports